import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { ReferencePerson } from '.'

export class GeneralRelation extends EnumEntity {
  @Type(() => ReferencePerson)
  referencePeople: ReferencePerson[];
}
